import images from "./images";

const projects = [
    {
        id: 1,
        image: images.project1,
        title: "Mountain Trek",
        details: {
            date: "Jan 15, 2024",
            client: "Outdoor Enthusiasts",
            category: "Tours",
            duration: "7 Days",
            location: "Rocky Mountains, Colorado",
            cost: "$1,200 per person",
            leadGuide: "John Summit"
        },
        paragraphs: [
            "Embark on an exhilarating Mountain Trek and explore the breathtaking beauty of nature. Whether you are a novice or an experienced hiker, our guided treks will offer an unforgettable adventure.",
            "Join us for our Mountain Trek, designed to provide an immersive experience in the great outdoors. Our experienced guides will lead you through scenic trails, helping you to appreciate the natural landscape while ensuring your safety and enjoyment."
        ],
        gallery: [
            images.project1Gallery1,
            images.project1Gallery2,
            images.project1Gallery3,
            images.project1Gallery4,
            images.project1Gallery5,
            images.project1Gallery6
        ],
        objectives: [
            "Experience the thrill of mountain trekking",
            "Learn basic trekking techniques and safety",
            "Master navigation and map reading skills",
            "Develop wilderness survival skills"
        ],
        challenges: [
            "Build stamina and endurance for long treks",
            "Navigate diverse terrains and weather conditions",
            "Develop confidence in outdoor survival and camping"
        ],
        solutions: [
            "Gain a deep appreciation for nature",
            "Experience camaraderie and teamwork",
            "Embrace personal growth and achievement"
        ]
    },
    
    {
        id: 2,
        image: images.project2,
        title: "Guided Hikes",
        details: {
            date: "Feb 20, 2024",
            client: "Adventure Seekers",
            category: "Education",
            duration: "4 Days",
            location: "National Parks, Wyoming",
            cost: "$800 per person",
            leadGuide: "Sarah Lorne"
        },
        paragraphs: [
            "Join our guided hikes to immerse yourself in the wonders of nature. Whether you're looking to learn survival skills or simply enjoy scenic views, our experienced guides will make your adventure both educational and enjoyable.",
            "Our expert guides provide in-depth knowledge about the local flora, fauna, and geology while ensuring safety and engagement throughout the hike. The experience is designed to offer both relaxation and a deeper understanding of the natural world."
        ],
        gallery: [
            images.project2Gallery1,
            images.project2Gallery2,
            images.project2Gallery3,
            images.project2Gallery4,
            images.project2Gallery5,
            images.project2Gallery6
        ],
        objectives: [
            "Learn about the natural environment",
            "Improve hiking skills with expert guidance",
            "Develop awareness of wildlife and plant life",
            "Gain knowledge on sustainable outdoor practices"
        ],
        challenges: [
            "Adapting to varying trail difficulties",
            "Weather-related hiking challenges",
            "Ensuring safety in remote areas"
        ],
        solutions: [
            "Guided instruction on hiking techniques",
            "Comprehensive training on outdoor survival",
            "Focus on safety protocols and emergency preparedness"
        ]
    },
    {
        id: 3,
        image: images.project3,
        title: "Forest Exploration",
        details: {
            date: "Mar 10, 2024",
            client: "Nature Enthusiasts",
            category: "Tours",
            duration: "5 Days",
            location: "Pacific Northwest Forests, Oregon",
            cost: "$950 per person",
            leadGuide: "Emily Green"
        },
        paragraphs: [
            "Embark on a captivating journey through the dense and mystical forests of the Pacific Northwest. Our Forest Exploration tour offers an unforgettable opportunity to experience the natural beauty of towering trees, diverse wildlife, and serene landscapes.",
            "Led by expert naturalists, you'll explore hidden trails, learn about the ecosystem, and enjoy the peaceful tranquility of the forest. This tour is designed for those seeking adventure, education, and relaxation in one of the most majestic natural environments."
        ],
        gallery: [
            images.project3Gallery1,
            images.project3Gallery2,
            images.project3Gallery3,
            images.project3Gallery4,
            images.project3Gallery5,
            images.project3Gallery6
        ],
        objectives: [
            "Discover the unique biodiversity of the forest",
            "Learn about sustainable ecosystems and conservation",
            "Experience a deep connection with nature",
            "Master outdoor survival skills through hands-on practice"
        ],
        challenges: [
            "Navigating dense forest terrain",
            "Dealing with weather conditions in remote areas",
            "Ensuring safety during off-trail explorations"
        ],
        solutions: [
            "Expert-guided navigation through forest paths",
            "Training on outdoor survival techniques",
            "Focus on maintaining group safety and comfort"
        ]
    },
    {
        id: 4,
        image: images.project4,
        title: "Trail Maintenance",
        details: {
            date: "April 25, 2024",
            client: "Community Volunteers",
            category: "Events",
            duration: "3 Days",
            location: "Blue Ridge Mountains, Virginia",
            cost: "Volunteer-based, No Charge",
            leadGuide: "Mark Thompson"
        },
        paragraphs: [
            "Join us for a hands-on trail maintenance event aimed at preserving the beautiful trails in the Blue Ridge Mountains. This event provides an opportunity for outdoor enthusiasts to give back to nature while learning essential trail care skills.",
            "Under the guidance of experienced trail experts, volunteers will work together to repair paths, clear debris, and improve safety for future hikers. Not only will you contribute to preserving the environment, but you'll also gain valuable skills in land stewardship."
        ],
        gallery: [
            images.project4Gallery1,
            images.project4Gallery2,
            images.project4Gallery3,
            images.project4Gallery4,
            images.project4Gallery5,
            images.project4Gallery6
        ],
        objectives: [
            "Improve trail accessibility and safety",
            "Promote environmental awareness and conservation",
            "Engage local communities in trail preservation",
            "Develop skills in outdoor maintenance and teamwork"
        ],
        challenges: [
            "Managing large groups of volunteers",
            "Working in varying weather conditions",
            "Ensuring minimal environmental impact during work"
        ],
        solutions: [
            "Coordinated group efforts to maximize efficiency",
            "Detailed safety protocols for adverse weather",
            "Sustainable practices to protect the ecosystem"
        ]
    },
    {
        id: 5,
        image: images.project5,
        title: "Wilderness Survival",
        details: {
            date: "June 10, 2024",
            client: "Survival Enthusiasts",
            category: "Education",
            duration: "5 Days",
            location: "Sierra Nevada, California",
            cost: "$500 per person",
            leadGuide: "Rachel Adams"
        },
        paragraphs: [
            "Master the essential skills needed to survive in the wild with our Wilderness Survival course. Over five days, you will learn everything from building shelters to identifying edible plants, all while exploring the rugged landscapes of the Sierra Nevada.",
            "Our expert instructors will teach you how to navigate the wilderness safely, make fire without matches, purify water, and find your way using only natural resources. Whether you're an outdoor enthusiast or a first-time adventurer, this course provides a solid foundation for any survival situation."
        ],
        gallery: [
            images.project5Gallery1,
            images.project5Gallery2,
            images.project5Gallery3,
            images.project5Gallery4,
            images.project5Gallery5,
            images.project5Gallery6
        ],
        objectives: [
            "Learn to build effective shelters in the wild",
            "Master fire-starting techniques using primitive methods",
            "Understand edible plants and natural food sources",
            "Navigate without a compass or modern tools"
        ],
        challenges: [
            "Limited access to modern resources during training",
            "Adapting to different weather and terrain conditions",
            "Ensuring safety while practicing survival techniques"
        ],
        solutions: [
            "Training in controlled environments to build confidence",
            "Weather-appropriate gear and training for diverse conditions",
            "Experienced instructors providing guidance at every step"
        ]
    },
    {
        id: 6,
        image: images.project6,
        title: "Clean-up Initiatives",
        details: {
            date: "April 20, 2024",
            client: "Environmental Groups",
            category: "Events",
            duration: "1 Day",
            location: "Lakeview Park, Oregon",
            cost: "Free Participation",
            leadGuide: "Alex Green"
        },
        paragraphs: [
            "Join us for a day of community-driven environmental action in our Clean-up Initiatives event. Volunteers will help remove litter, recycle materials, and restore natural beauty to local parks and waterways.",
            "This event aims to raise awareness about the importance of environmental conservation and encourage active participation in protecting our surroundings. All necessary tools and supplies will be provided for volunteers to contribute meaningfully to the cause."
        ],
        gallery: [
            images.project6Gallery1,
            images.project6Gallery2,
            images.project6Gallery3,
            images.project6Gallery4,
            images.project6Gallery5,
            images.project6Gallery6
        ],
        objectives: [
            "Promote environmental awareness and community involvement",
            "Collect and recycle waste materials in local parks",
            "Encourage sustainable practices through clean-up efforts",
            "Restore local ecosystems by reducing pollution"
        ],
        challenges: [
            "Dealing with large volumes of waste in remote areas",
            "Coordinating large groups of volunteers effectively",
            "Ensuring proper disposal and recycling of collected materials"
        ],
        solutions: [
            "Providing volunteers with clear guidelines and safety instructions",
            "Designating specific areas for efficient waste collection",
            "Partnering with recycling organizations for proper disposal"
        ]
    },

];

export default projects;